import { Delivery, Parcel } from '~api/som';

export const getDeliveries = (parcels?: Parcel[]) =>
  parcels?.filter(p => p.id).flatMap(p => p.deliveries?.filter(d => d.id).flatMap(d => d) as Delivery) ?? [];
